import common from "../../common";
import ConfirmButton from "../ConfirmButton";
import ConfirmHackButton from "../ConfirmHackButton";
import GelButton from "../gel/GelButton";
import GelHackButton from "../gel/GelHackButton";

export default class QuestionView extends PIXI.Container {
    constructor(question) {
        super();

        this.signals = {
            select: new P3.utils.MiniSignal(),
            confirm: new P3.utils.MiniSignal()
        };

        this._question = question;
        this._header = null;
        this._footer = null;
        this._inputValue = null;
        this._inputField = null;

        this.initHeader();
        this.initFooter();
        this.initInputField();
        this.initConfirmButton();

        this.on("added", this.added, this);
    }

    destroy() {
        P3.utils.destroyAllSignals(this.signals);

        super.destroy({children: true});
    }

    added() {
        this.off("added", this.added, this);

        this._confirmButton.resize && this._confirmButton.resize();
    }

    update(dt) {
        //this._confirmButton.emitter.update(dt);
    }

    hideInputField() {
        this._inputField.visible = false;
    }

    initHeader() {
        this._header = new PIXI.Container();
        this.addChild(this._header);

        this._header.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("question_box_9slice"), 88, 44, 88, 44);
        this._header.image.position.set(0);
        this._header.image.width = 740;
        this._header.image.pivot.set(this._header.image.width * 0.5, this._header.image.height * 0.5);
        this._header.addChild(this._header.image);

        this._header.label = new PIXI.extras.BitmapText(this.getHeaderText(), {
            font: {name: "BBC Reith Sans Math Large", size: 24},
            tint: 0x0,
            align: "center"
        });
        this._header.label.anchor.set(0.5);
        this._header.label.maxWidth = this._header.image.width - 100;
        this._header.addChild(this._header.label);

        this.resizeHeaderToFitText()
    }

    initFooter() {
        this._footer = new PIXI.Container();
        this.addChild(this._footer);

        this._footer.image = new PIXI.mesh.NineSlicePlane(P3.assets.texture("answer_box_9slice"), 88, 88, 88, 88);
        this._footer.image.position.set(0);
        this._footer.image.width = 820;
        this._footer.image.pivot.set(this._footer.image.width * 0.5, this._footer.image.height * 0.5);
        this._footer.addChild(this._footer.image);
    }

    initInputField() {
        this._inputField = new PIXI.Sprite(P3.assets.texture("ui_drop_in_answerbox"));
        this._inputField.anchor.set(0.5);
        this._footer.addChild(this._inputField);

        this._inputField.label = new PIXI.Text("?", {fontSize: 48, fontFamily: "BBC Reith Sans", fontWeight: "bold", wordWrap : true, wordWrapWidth: 125});
        this._inputField.label.anchor.set(0.5);
        this._inputField.label.resolution = 2;
        this._inputField.addChild(this._inputField.label);
    }

    initConfirmButton() {
        const states = new P3.ButtonStates();
        states.normal = P3.assets.texture("ui_btn_confirm_out");
        states.over = P3.assets.texture("ui_btn_confirm_over");
        states.down = P3.assets.texture("ui_btn_confirm_down");
        states.icon = P3.assets.texture("ui_icon_accept_medium");
        states.normalInactive = P3.assets.texture("ui_btn_fail_out");
        states.overInactive = P3.assets.texture("ui_btn_fail_over");
        states.downInactive = P3.assets.texture("ui_btn_fail_down");
        states.iconInactive = P3.assets.texture("ui_icon_decline_medium");

        this._confirmButton = PIXI.utils.isMobile.any ? new ConfirmButton(states) : new ConfirmHackButton(states);
        this._confirmButton.tabIndex = GelButton.TAB_INDEX_LEVEL_2;
        this._confirmButton.signals.click.add(this.onConfirmButtonClick, this);
        this._footer.addChild(this._confirmButton);

        //const config = P3.assets.json("particle_attract_button_large_0");
        //this._confirmButton.emitter = new PIXI.particles.Emitter(this._confirmButton, [
        //    P3.assets.texture("particle_coin_1")
        //], config);
        //this._confirmButton.emitter.emit = true;
    }

    resizeHeaderToFitText() {
        const padding = 60;
        let height = Math.max(128, this._header.label.textHeight + padding);

        const limit = 200;
        if (height > limit) {
            let size = this._header.label.font.size;
            size /= height / limit;

            this._header.label.font.size = size;
            this._header.label.updateText();

            height = Math.max(128, this._header.label.textHeight + padding);
        }
        this._header.image.height = height;
        this._header.image.pivot.y = this._header.image.height * 0.5;
    }

    getHeaderText() {
        const templates = P3.assets.json("templates").templates;
        const split = this._question.template.split("/");
        const text = P3.utils.selectRandom(P3.utils.objectToArray(templates[split[0]][split[1]])).text;
        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    setHeaderText(value) {
        this._header.label.text = value;
    }

    setAnswer(value) {
        this._inputValue = value;

        if (this._inputField != null)
        {
            if (value) {
                const str = value.toString();
                this._inputField.label.text = str;

                let size = 40;
                switch (true) {
                    case str.length >= 8 : {
                        size = 14;
                        break;
                    }
                    case str.length >= 5 : {
                        size = 20;
                        break;
                    }
                }
                this._inputField.label.style.fontSize = size;
            } else {
                this._inputField.label.text = "?";
                this._inputField.label.style.fontSize = 40;
            }
        }
    }

    setInputFieldHeight(y) {
        if (this._inputField) this._inputField.y = y;
    }

    onConfirmButtonClick(button) {
        if (this._inputValue) {
            this._confirmButton.enabled = false;
            this.signals.confirm.dispatch(this, this.isCorrect());
        }
    }

    isCorrect() {
        return this._inputValue ? this._inputValue.value === this._question.answer.value : false;
    }

    filterTemplate(x) {
        return true;
    }

    get headerHeight() {
        return this._header.image.height;
    }

    get footerHeight() {
        return this._footer.image.height;
    }

    get question() {
        return this._question;
    }

    get answer() {
        return this._inputValue;
    }

    get header() {
        return this._header;
    }

    get footer() {
        return this._footer;
    }

    get confirmButton() {
        return this._confirmButton;
    }
}

QuestionView.VIEW_STATEMENT                 = "statement";
QuestionView.VIEW_STATEMENT_MULTI           = "statement_multi";
QuestionView.VIEW_STATEMENT_FRACTION        = "statement_fraction";
QuestionView.VIEW_STATEMENT_LONG            = "statement_long";

QuestionView.VIEW_STATEMENT_ALGEBRA         = "statement_algebra";
QuestionView.VIEW_STATEMENT_ALGEBRA_PAIR    = "statement_algebra_pair";

QuestionView.VIEW_SORT                      = "sort";
QuestionView.VIEW_VISUAL                    = "visual";
QuestionView.VIEW_COMPARISON                = "comparison";

QuestionView.VIEW_SEQUENCE                  = "sequence";

QuestionView.VIEW_VERBAL                    = "verbal";
QuestionView.VIEW_VERBAL_BOOLEAN            = "verbal_boolean";
QuestionView.VIEW_VERBAL_VALUE              = "verbal_value";
QuestionView.VIEW_VERBAL_EXPONENT           = "verbal_exponent";
QuestionView.VIEW_VERBAL_CONVERSION         = "verbal_conversion";
QuestionView.VIEW_VERBAL_VOLUME             = "verbal_volume";
QuestionView.VIEW_VERBAL_SHAPE              = "verbal_shape";
QuestionView.VIEW_VERBAL_EQUIVALENT         = "verbal_equivalent";
QuestionView.VIEW_VERBAL_TIME               = "verbal_time";
QuestionView.VIEW_VERBAL_COMPOSE            = "verbal_compose";
QuestionView.VIEW_VERBAL_RATIO              = "verbal_ratio";
QuestionView.VIEW_VERBAL_MULTIPLES          = "verbal_multiples";
QuestionView.VIEW_VERBAL_ROUND              = "verbal_round";
QuestionView.VIEW_VERBAL_SUM                = "verbal_sum";
QuestionView.VIEW_VERBAL_REST               = "verbal_rest";
QuestionView.VIEW_VERBAL_STATS              = "verbal_stats";
QuestionView.VIEW_VERBAL_ANGLE              = "verbal_angle";

QuestionView.VIEW_VISUAL_TIME               = "visual_time";
QuestionView.VIEW_VISUAL_CLOCK_FACE         = "visual_clock_face";
QuestionView.VIEW_VISUAL_LIQUID             = "visual_liquid";
QuestionView.VIEW_VISUAL_EQUIVALENT         = "visual_equivalent";
QuestionView.VIEW_VISUAL_ROTATED_SHAPE      = "visual_rotated_shape";
QuestionView.VIEW_VISUAL_SHAPE              = "visual_shape";

QuestionView.VIEW_GRAPH_VEN                 = "graph_ven";
QuestionView.VIEW_GRAPH_BAR                 = "graph_bar";
QuestionView.VIEW_GRAPH_TALLY               = "graph_tally";
QuestionView.VIEW_GRAPH_LINE                = "graph_line";

QuestionView.STATIC_VERBAL                  = "static_verbal";